<template>
  <header class="sticky top-0 left-0 bg-white" style="z-index: 51">
    <div
      class="flex px-[24px] w-full relative justify-between h-18 border-b border-mid-neutral-50 items-center"
    >
      <div class="flex items-center gap-2">
        <button
          class="px-3 py-1 text-xs border rounded text-dark-neutral-400 hover:bg-mid-neutral-20"
          @click="onClearIndexedDB"
          v-tooltip.bottom.light="
            'Clear all locally cached data (IndexedDB) and reload'
          "
        >
          Clear DB
        </button>
      </div>

      <div class="text-dark-neutral-500 font-bold">Compliance</div>
      <button
        class="font-semibold border p-5 text-white rounded-full bg-primary-50 w-5 h-5 text-sm uppercase flex items-center justify-center"
      >
        <div class="flex items-center">
          <p class="font-medium text-base text-primary-500">U</p>
        </div>
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { clearIndexedDB } from "utils";

async function onClearIndexedDB() {
  try {
    await clearIndexedDB();
  } finally {
    location.reload();
  }
}
</script>
